import React from 'react';

import { BsFillPlayFill, BsFillPauseFill, BsShuffle, BsSkipBackwardFill, BsSkipForwardFill, BsVolumeDownFill, BsVolumeUpFill, BsVolumeMuteFill } from 'react-icons/bs'
import { TbRepeat, TbRepeatOff, TbRepeatOnce } from 'react-icons/tb'


const mp3file = "https://github.com/liljdot/test/raw/main/04.%20No%20Option.mp3"




export function AudioPlayer(props) {
    const audioPlayer = React.useRef()
    const [isPlaying, setIsplaying] = React.useState(false)
    const [duration, setDuration] = React.useState(0)
    const [currentTime, setCurrentTime] = React.useState('0:00')
    const [isMute, setIsMute] = React.useState(false);
    const [audioVolume, setAudioVolume] = React.useState(100);
    const [repeatState, setRepeatState] = React.useState('no')
    const [artist, setArtist] = React.useState('')
    const track = props.track
    const forcedIsPlaying = props.forcedIsPlaying
    

    React.useEffect(() => {
        setDuration(calculateMinutes(audioPlayer.current.duration))
       
        if (isPlaying) {
            const intervalId = setInterval(() => {
                setCurrentTime(calculateMinutes(audioPlayer.current.currentTime))
                if (audioPlayer.current.currentTime === audioPlayer.current.duration) {
                    setIsplaying(false)
                }
                if (duration !== calculateMinutes(audioPlayer.current.duration)) {
                    setDuration(calculateMinutes(audioPlayer.current.duration))
                }
            }, 1000)
            console.log(window)
            return () => { clearInterval(intervalId) }


        }

    }, [mp3file, isPlaying])

    React.useEffect(() => {
       if (forcedIsPlaying) {
            audioPlayer.current.play()
            setIsplaying(true)
        }
    }, [track])

    const calculateMinutes = (seconds) => {
        if (seconds > 0) {
            const mins = Math.floor(seconds / 60) < 10 ? `0${Math.floor(seconds / 60)}` : Math.floor(seconds / 60)
            const secs = Math.floor(seconds % 60) < 10 ? `0${Math.floor(seconds % 60)}` : Math.floor(seconds % 60)
            return `${mins}:${secs}`
        } else {
            return '0:00'
        }
    }

    const playToggle = () => {
        if (isPlaying) {
            audioPlayer.current.pause();
            setIsplaying(false)
            props.forcePause()
        } else {
            audioPlayer.current.play();
            setIsplaying(true)
        }
    }

    const toggleMute = () => {
        if (isMute) {
            audioPlayer.current.muted = false
            setIsMute(false)
        } else {
            audioPlayer.current.muted = true
            setIsMute(true)
        }
    }

    const changeCurrentTime = ({ target }) => {
        setCurrentTime(calculateMinutes(target.value))
        audioPlayer.current.currentTime = target.value
    }

    const changeVolume = ({ target }) => {
        setAudioVolume(target.value)
        audioPlayer.current.volume = target.value / 100
        setIsMute(false)
        audioPlayer.current.muted = false
    }

    const toggleMaxVolume = () => {
        setAudioVolume(100)
        audioPlayer.current.volume = 1
        if (isMute) {
            setIsMute(false)
            audioPlayer.current.muted = false
        }
    }

    const toggleRepeat = () => {
        switch (repeatState) {
            case 'yes': audioPlayer.current.loop = true
                setRepeatState('once')
                break;
            case 'once': audioPlayer.current.loop = false
                setRepeatState('no')
                break;
            case 'no': audioPlayer.current.loop = false
                setRepeatState('yes')
        }


    }

    return (
        <div>
            <audio ref={audioPlayer} controls src={track ? track.url : '...'} preload></audio>
            <div class='audio-player'>
                <h4>Now Playing</h4>
                <div class='player-img' style={{backgroundImage: track ? `url(${track.albumArt})` : 'url("https://www.seoclerk.com/pics/555434-1FzqjL1503944654.png")', backgroundSize: '100% 100%'}} ></div>
                <h4>{track ? track.songName : '...'}</h4>
                <h5>{track ? track.artist : '...'}</h5>
                <div id='time'>
                    <p id='current-time'>{currentTime}</p>
                    <div class='slider'>
                        <input type='range' max={duration ? audioPlayer.current.duration : 0} onChange={changeCurrentTime} value={duration ? audioPlayer.current.currentTime : 0} ></input>
                    </div>
                    <p id='duration'>{duration}</p>
                </div>
                <div class='media-buttons'>
                    <button><BsShuffle /></button>
                    <button><BsSkipBackwardFill /></button>
                    <button onClick={playToggle}>{!isPlaying ? <BsFillPlayFill /> : <BsFillPauseFill />}</button>
                    <button><BsSkipForwardFill /></button>
                    <button onClick={toggleRepeat}>{repeatState === 'yes' ? <TbRepeat /> : repeatState === 'once' ? <TbRepeatOnce /> : <TbRepeatOff />}</button>
                </div>
                <div id='time'>
                    <button onClick={toggleMute}>{duration ? (audioPlayer.current.muted ? <BsVolumeMuteFill /> : <BsVolumeDownFill />) : <BsVolumeDownFill />}</button>
                    <div class='slider' id='volbar'>
                        <input type='range' value={audioVolume} max={100} onChange={changeVolume}></input>
                    </div>
                    <button onClick={toggleMaxVolume}><BsVolumeUpFill /></button>
                </div>
            </div>
        </div>
    )
}